import gql from 'graphql-tag'
import { TypedDocumentNode } from '@apollo/client'
import { TrackedTowingRecord } from './types'

export interface ReportLocationVariables {
  location: { lat: number; long: number; accuracy?: number }
}

export interface ReportLocationResponse {
  reportLocation: { __typename: string }
}

export const TOWING_RECORDS_ACTIVE: TypedDocumentNode<ActiveJobsResponse, Record<string, never>> = gql`
  query ActiveTowingRecords {
    activeTowingRecords {
      __typename
      ... on ActiveJobsSuccess {
        activeJobs {
          id
          type
          typeIdentifier
          jobStatus
        }
      }
    }
  }
`

export const GEOLOCATION_REPORT_POSITION: TypedDocumentNode<ReportLocationResponse, ReportLocationVariables> = gql`
  query ReportLocation($location: ReportLocation!) {
    reportLocation(location: $location) {
      __typename
    }
  }
`

export interface ActiveJobsResponse {
  activeTowingRecords: ActiveJobsResult
}

interface ActiveJobsResult
  extends Readonly<{
    __typename: string
    activeJobs: TrackedTowingRecord[]
  }> {}
